import React, { type ReactNode } from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import { Box, xcss } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import type { ReferenceType } from '../../../controllers/configuration/types.tsx';

type Props = {
	referenceTypes: ReferenceType[];
	onChange: (updated: ReferenceType) => void;
};

export const ReferenceTypeToggleList = (props: Props) => {
	const { referenceTypes, onChange } = props;

	const onToggleReferenceType = (referenceTypeToUpdate: ReferenceType) => {
		const updatedReferenceType = {
			...referenceTypeToUpdate,
			checked: !referenceTypeToUpdate.checked,
		};
		onChange(updatedReferenceType);
	};

	return (
		<Box xcss={containerStyles}>
			{referenceTypes.map((rt: ReferenceType) => (
				<Box xcss={inputContainerStyles} key={rt.label}>
					<Checkbox
						isChecked={rt.checked}
						onChange={() => onToggleReferenceType(rt)}
						testId={`assets-object-graph.ui.graph-config-panel.reference-types-toggle-list.checkbox-${rt.label}`}
						aria-label={fg('assets_enghealth_aurum-1') ? rt.label : undefined}
					/>
					<ColorCircle color={rt.color} />
					<Box xcss={labelTextStyles} as="p">
						{rt.label}
					</Box>
				</Box>
			))}
		</Box>
	);
};

const ColorCircle = ({ color, children }: { color: string; children?: ReactNode }) => (
	<Box
		xcss={colorCircleStyles}
		// eslint-disable-next-line jira/react/no-style-attribute
		style={{
			backgroundColor: color,
		}}
	>
		{children}
	</Box>
);

const labelTextStyles = xcss({
	marginTop: 'space.100',
	marginRight: 'space.100',
	marginBottom: 'space.100',
	marginLeft: 'space.100',
});

const inputContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	marginBottom: 'space.100',
	wordWrap: 'break-word',
	overflowWrap: 'break-word',
	wordBreak: 'break-word',
});

const containerStyles = xcss({
	marginTop: 'space.200',
});

const colorCircleStyles = xcss({
	height: '28px',
	minWidth: '28px',
	borderRadius: 'radius.full',
});
